import { URL_BASE } from '@collaborator/npm_modules/dist/components/NetworkService/constants';

const DEAL_REPEAT_SUCCESS = 'DEAL_REPEAT_SUCCESS';

const DEAL_REJECT_CLIENT_URL = '/deal/action/reject-client';
const DEAL_COMPLETE_URL = '/deal/action/complete';
const DEAL_REWORK_READY_URL = '/deal/action/rework-ready';
const DEAL_ARBITRATION_URL = '/deal/action/arbitration';
const DEAL_REPEAT_URL = '/deal/action/repeat';
const DEAL_IN_WORK_URL = '/deal/action/in-work';
const DEAL_REJECT_URL = '/deal/action/reject';
const DEAL_READY_URL = '/deal/action/ready';
const DEAL_DETAIL_LOAD_URL = '/deal/detail/load';
const DEAL_DOWNLOAD_IMAGES_URL = `${URL_BASE}/deal/detail/download-images`;

const GET_PARAM_SELECTED_DEAL_ID = 'selectedDealId';

export {
  DEAL_REPEAT_SUCCESS,

  DEAL_REJECT_CLIENT_URL,
  DEAL_COMPLETE_URL,
  DEAL_REWORK_READY_URL,
  DEAL_REPEAT_URL,
  DEAL_ARBITRATION_URL,
  DEAL_IN_WORK_URL,
  DEAL_REJECT_URL,
  DEAL_READY_URL,
  DEAL_DETAIL_LOAD_URL,
  DEAL_DOWNLOAD_IMAGES_URL,

  GET_PARAM_SELECTED_DEAL_ID,
};
